import { UIHeading3, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

export const getTitleComponent = (title: string, showNarrowCards: boolean) => {
  return showNarrowCards ? <UIHeading4>{title}</UIHeading4> : <UIHeading3>{title}</UIHeading3>;
};
